<script>
    import RangeSlider from 'vue-range-slider'
    import 'vue-range-slider/dist/vue-range-slider.css'

    export default {
        components: { RangeSlider },
        data: () => ({
            sliderValue: 0,
            showResult: false,
            amount: null,
            currentSector: {
                id: 1,
                title: 'Resto de giros',
                rate: {
                    once: 2.50,
                    msi3: 5.57,
                    msi6: 9.49,
                    msi9: 13.19,
                    msi12: 16.70,
                }
            },
            sectors: [
                {
                    id: 1,
                    title: 'Resto de giros',
                    rate: {
                        once: 2.50,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 2,
                    title: 'Médicos y dentistas',
                    rate: {
                        once: 0.60,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 3,
                    title: 'Refaccionarias y Ferreterías',
                    rate: {
                        once: 0.60,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 4,
                    title: 'Misceláneas',
                    rate: {
                        once: 0.60,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 5,
                    title: 'Salones de belleza',
                    rate: {
                        once: 0.60,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 6,
                    title: 'Educación básica y Guarderías',
                    rate: {
                        once: 0.60,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                },
                {
                    id: 7,
                    title: 'Atracción de competencia',
                    rate: {
                        once: 1.50,
                        msi3: 5.57,
                        msi6: 9.49,
                        msi9: 13.19,
                        msi12: 16.70,
                    }
                }
            ]
        }),
        computed:{
            getPayMethod(){
                if (this.sliderValue === 0) return 'once'
                if (this.sliderValue === 25) return 'msi3'
                if (this.sliderValue === 50) return 'msi6'
                if (this.sliderValue === 75) return 'msi9'
                if (this.sliderValue === 100) return 'msi12'
            },
            totals(){
                let iva, totalReceived, discount;
                let commission =  ((this.amount / 100) * this.currentSector.rate[this.getPayMethod]).toFixed(2)
                let transactionCommission =  ((this.amount / 100) * this.currentSector.rate.once).toFixed(2);
                iva = ((16 * commission ) / 100).toFixed(2)
                totalReceived = (this.amount - commission - iva).toFixed(2)
                discount = (Number(iva) + Number(transactionCommission)).toFixed(2)

                if (this.sliderValue != 0) {
                    iva = (((Number(commission) + Number(transactionCommission)) * 16) / 100).toFixed(3)
                    totalReceived = (this.amount - Number(transactionCommission) - Number(commission) - Number(iva)).toFixed(2)
                    discount = (Number(iva) + Number(commission) + Number(transactionCommission)).toFixed(2)
                }

                return [totalReceived, discount ]
            }
        },
        methods: {
            calculate(){
                this.showResult = !this.showResult
                this.$emit('stepTwo')
            },
            hiddeResult(){
                this.showResult = false
                this.$emit('stepTwo')
            },
            selectSector(event){
                const id = Number(event.target.value)
                const item = this.sectors.find(item => item.id === id)
                this.currentSector = item
            }
        }
    }
</script>

<template>
    <div class="calculator">
        <!-- INPUTS -->
        <div v-if="!showResult">
            <div class="box box--white py-10 px-20 rounded-20 mb-10">
                <div class="grid grid-cols-2 gap-25 mb-9">

                    <!-- SELECT -->
                    <div class="form-group">
                        <label class="form-label flex align-center" for="">
                            <div class="grid place-items-center h-11 mr-2">
                                <img class="w-10" src="./assets/images/branch-office-glass.png" alt="">
                            </div>
                            Selecciona el tipo de giro de tu cliente
                        </label>
                        <select class="form-input form-input-select" name="" id="" @change="selectSector($event)">
                            <!-- <option disabled selected>Giro del negocio</option> -->
                            <option :value="item.id" v-for="item in sectors" :key="item.title">
                                {{ item.title }}
                            </option>
                        </select>
                    </div>

                    <!-- INPUT -->
                    <div class="form-group">
                        <label class="form-label flex align-center" for="">
                            <div class="grid place-items-center h-11 mr-2">
                                <img class="w-10" src="./assets/images/ticket-glass.png" alt="">
                            </div>
                            ¿Cuál es el ticket promedio de venta de tu cliente?
                        </label>
                        <input class="form-input" type="number" placeholder="Monto promedio de ticket de venta, ejemplo: 1000" v-model="amount">
                    </div>
                </div>

                <p class="tx-24 tx-center">
                    Modo de pago
                </p>

                <!-- RANGE SLIDER -->
                <range-slider
                    class="slider w-100pr mb-5"
                    min="0"
                    max="100"
                    step="25"
                    v-model="sliderValue">
                </range-slider>

                <div class="tx-center flex justify-between mb-13">
                    <div class="w-22 -ml-6">
                        Pago <br> Único
                    </div>
                    <div class="w-22">
                        <strong>3 meses</strong> <br> sin intereses
                    </div>
                    <div class="w-22">
                        <strong>6 meses</strong> <br> sin intereses
                    </div>
                    <div class="w-22">
                        <strong>9 meses</strong> <br> sin intereses
                    </div>
                    <div class="w-22 -mr-6">
                        <strong>12 meses</strong> <br> sin intereses
                    </div>
                </div>

                <button class="btn btn--blue-1 tx-white flex w-60 mx-auto" @click="calculate()" v-if="amount != null">
                    Calcular
                </button>
            </div>

            <div class="tx-12">
                <p class="mb-0">
                    Material de uso interno
                </p>
                <p>
                    Aplican restricciones
                </p>
            </div>
        </div>

        <!-- RESULT -->
        <div v-if="showResult">
            <div class="mx-auto" style="max-width: 900px;">
                <div class="flex align-center w-fit cursor-pointer mb-10" @click="hiddeResult()">
                    <img class="mr-2 -mb-1" src="./assets/images/arrow-l.png" alt="">
                    Regresar
                </div>
            </div>
            <div class="box box-blue tx-white bg-purple-1 py-8 px-20 rounded-20 mx-auto">
                <p class="tx-20 tx-center">
                    Tu cliente recibe:
                </p>
                <div class="form-input grid place-items-center mb-10">
                    <span class="tx-26">
                        ${{ totals[0] }}
                    </span>
                </div>
                <p class="tx-20 tx-center">
                    <span v-if="sliderValue === 0">
                        Tasa de descuento {{ Number(currentSector.rate[getPayMethod]).toFixed(2) }}% <br> (incluye iva)
                    </span>
                    <span v-else>
                        Tasa {{ currentSector.rate.once }}% + Sobretasa de MSI {{ currentSector.rate[getPayMethod] }} <br> (incluye iva)
                    </span>
                </p>
<!--                 <p class="tx-center">
                    Comisión + IVA
                </p> -->
                <div class="form-input grid place-items-center">
                    <span class="tx-26">
                        ${{ totals[1] }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .box-blue{
        max-width: 600px;
    }
</style>